export default "__VITE_ASSET__Func9kH9__"